import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filtro-padrao-obra',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-padrao-obra.component.html',
  styleUrl: './filtro-padrao-obra.component.scss',
})
export class FiltroPadraoObraComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  filtroPadraoObra: Array<any> = [];

  @Output() padroesObraChange = new EventEmitter<any[]>();
  @Input() padroesSelecionados: number[] = [];

  private readonly _errorHandleService = inject(ErrorHandleService);
  private subscription = new Subscription();

  constructor(private readonly _filtroBuscaService: FiltroBuscaService) {}

  ngOnInit(): void {
    this.filtrarPorPadraoDeObra();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['padroesSelecionados'] && this.filtroPadraoObra.length) {
      const selecionados = Array.isArray(this.padroesSelecionados)
        ? this.padroesSelecionados
        : [];
      this.filtroPadraoObra = this.filtroPadraoObra.map((item) => ({
        ...item,
        checked: selecionados.includes(item.id),
      }));
    }
  }

 filtrarPorPadraoDeObra() {
  this.subscription.add(
    this._filtroBuscaService.buscarFiltroPadraoObra().subscribe({
      next: (res) => {
        if (res.success) {
          const selecionados = Array.isArray(this.padroesSelecionados)
            ? this.padroesSelecionados
            : [];

          this.filtroPadraoObra = res.data.map((item: any) => ({
            ...item,
            checked: selecionados.includes(item.id),
          }));
        } else {
          this._errorHandleService.throwConsoleError(res.message);
        }
      },
    })
  );
}

  onCheckChange(event: Event, option: any) {
    option.checked = (event.target as HTMLInputElement).checked;
    const selecionados = this.filtroPadraoObra.filter((o: any) => o.checked);
    this.padroesObraChange.emit(selecionados);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
